import type { ReactNode } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { IdentityContext, type Identity } from "./identity";

/** Auth0 tal cual: la app recibe el mismo objeto de useAuth0() que antes. */
export function Auth0Bridge({ children }: { children: ReactNode }) {
  const auth0 = useAuth0();
  const identity = { ...auth0, provider: "auth0" } as unknown as Identity;
  return <IdentityContext.Provider value={identity}>{children}</IdentityContext.Provider>;
}
